import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-pick-configure-displayed',
  templateUrl: './pick-configure-displayed.component.html',
  styleUrls: ['./pick-configure-displayed.component.scss']
})
export class PickConfigureDisplayedComponent implements OnInit {
  showMethods = {
    supportEkyc: false,
    checkName: true,
    checkOtp: true,
    checkCertNumber: true,
    allowEKYC: false,
    allowEkycAdvanced: false,
  }
  methodDontShow: any;
  count: number;
  isShowEkyc: boolean;
  isReadySignEkyc: boolean = false;
  isReadySignEkycAdvanced: boolean = false;

  constructor(
    public diaLogRef: MatDialogRef<PickConfigureDisplayedComponent>,
    @Inject(MAT_DIALOG_DATA) public dataInput: any
  ) {
    diaLogRef.disableClose = false;
  }

  ngOnInit() {
    this.showMethods.supportEkyc = this.dataInput.supportEkyc;
    this.showMethods.checkCertNumber = this.dataInput.checkCertNumber;
    this.showMethods.checkName = this.dataInput.checkName;
    this.showMethods.checkOtp = this.dataInput.checkOtp;
    this.isShowEkyc = this.dataInput.isShowEkyc;

    this.showMethods.allowEKYC = this.dataInput.allowEKYC;
    this.showMethods.allowEkycAdvanced = this.dataInput.allowEkycAdvanced;
    this.isReadySignEkyc = this.dataInput.isReadySignEkyc;
    this.isReadySignEkycAdvanced = this.dataInput.isReadySignEkycAdvanced;
    this.getMethodDontShow();
    this.getCountAllow();
  }

  onCloseDialog() {
    this.diaLogRef.close({data: this.methodDontShow, count: this.count});
    localStorage.setItem('configureDisplayed', JSON.stringify({data: this.methodDontShow, count: this.count}));
  }

  onChangeStatus(type) {
    this.showMethods[type] = !this.showMethods[type];
    this.getCountAllow();
    this.getMethodDontShow();
  }
  getMethodDontShow() {
    const allMethods = Object.keys(this.showMethods);
    this.methodDontShow = allMethods.filter( method => !this.showMethods[method])
  }

  getCountAllow() {
    this.count = 0;
    for(let key in this.showMethods) {
      if(this.showMethods[key]) {
        this.count++;
      }
    }
  }

  ngOnDestroy(): void {
    this.onCloseDialog()
  }
}
